<template>
  <div v-if="isNewJob ? true : isFetched">
    <TagsDisplay :tags="displayTags" class="mr-1" />
    <v-tooltip v-if="displayTags && displayTags.length > 0" left>
      <template #activator="{ on }">
        <span v-on="on">
          <vs-button type="secondary" icon="mdi-pencil" small @click="handleClickEditTagsButton" />
        </span>
      </template>
      <span>Change or add tags</span>
    </v-tooltip>

    <vs-button
      v-if="!displayTags || displayTags.length === 0"
      label="Add Tags"
      type="secondary"
      icon="mdi-plus"
      small
      @click="handleClickEditTagsButton"
    />
  </div>
</template>

<script setup lang="ts">
import VsButton from '@/components/vision/VsButton.vue'
import TagsDisplay from '@/components/common/tags/TagsDisplay.vue'
import { toRef, computed } from 'vue'
import { useGetJobTagsQuery } from '@/api/jobs'
import { useJobFormDataStore } from '@/components/jobs/jobFormDataStore'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'

const props = defineProps<{
  jobId?: string | null // Job UUID - If null, then we are creating new jobs
}>()
const jobIdRef = toRef(props, 'jobId')
const isNewJob = computed(() => !props.jobId)

const { data: tags, isFetched } = useGetJobTagsQuery(jobIdRef)

const jobFormDataStore = useJobFormDataStore()
const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

const displayTags = computed(() => {
  if (props.jobId) {
    return tags.value || []
  }
  return jobFormDataStore.draftTags
})

const handleClickEditTagsButton = () => {
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isTagBottomSheetVisible: true,
  })
}
</script>
